import NotificationNotipay from "../index.js";
const routes = [
    { name: "NotificationNotipayList", path: "/notificationnotipay", component: NotificationNotipay.NotificationNotipayListPage, meta: { title: "Notification Notipay" } },
    { name: "NotificationNotipayView", path: "/notificationnotipay/view/:id", component: NotificationNotipay.NotificationNotipayViewPage, meta: { title: "Notification Notipay" } },
];

export default routes;
